// Consent-aware analytics - must load before any tracking scripts
import './js/analytics/consent-datalayer-manager.js';
import './dayjs.js';

import * as Turbo from '@hotwired/turbo';
import { registerSvelteControllerComponents } from '@symfony/ux-svelte';

import 'core-js/actual/structured-clone';
import './js/sentry.js';
import './css/main.scss';

// start the Stimulus application
import { startStimulusApp } from '@symfony/reprise/stimulus';

// Import Svelte components individually
import CurrencyStoreController from './svelte/saga/controllers/CurrencyStoreController.svelte';

Turbo.session.drive = false;

// Registers Stimulus controllers from controllers.json and in the controllers/ directory
startStimulusApp();

// Create a custom context function that behaves like import.meta.webpackContext for registerSvelteControllerComponents to work
const customContext = function (key) {
    return customContext._components[key];
};

customContext._components = {
    './CurrencyStoreController.svelte': {
        default: CurrencyStoreController,
    },
};

customContext.keys = function () {
    return Object.keys(this._components);
};

// Register our Svelte components
registerSvelteControllerComponents(customContext);
